import { toast, Flip } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { postShoppingCart } from "src/shared/services/servicesv2";

interface SaveCartParams {
  condition: number;
  disValue: number;
  totalAmount: number;
  totalQuantity: number;
  deliveryFee: number;
  selectedProductslist: any[];
  valueMap: { [key: string]: number };
  setCartId: (id: string) => void;
}

export const useCartSave = ({ condition, disValue, totalAmount, totalQuantity, deliveryFee, selectedProductslist, valueMap, setCartId }: SaveCartParams) => {
  const navigation = useNavigate();

  const Savecart = async (checkout: string | null) => {
    if (totalAmount <= 0) {
      toast.warn("Please select at least one product", {
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
        transition: Flip,
      });
      return;
    }

    const currentDate = new Date();
    const cartId = `${String(currentDate.getMonth() + 1).padStart(2, "0")}${String(currentDate.getDate()).padStart(2, "0")}${String(currentDate.getHours()).padStart(2, "0")}${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}${String(currentDate.getSeconds()).padStart(2, "0")}`;

    const orderData = {
      discount: condition,
      totalPrice: disValue,
      products: selectedProductslist.map((product) => {
        const unitPrice = Number(product.amount) || 0;
        const quantity = Number(valueMap[`${product._id.$oid}-${product.amount}`]) || 1;
        return {
          productId: product._id.$oid,
          productName: product.productName,
          arabicName: product.arabicName,
          unitPrice,
          quantity,
          itemTotal: unitPrice * quantity,
        };
      }),

      orderAmount: totalAmount,
      deliveryFee,
      Finalamount: disValue || totalAmount + deliveryFee,
      finalAmount: disValue || totalAmount,
      totalQuantity,
      cartId,
    };

    try {
      const res = await postShoppingCart(orderData);
      setCartId(res.data._id);

      if (!checkout) {
        navigation(`/v1/cart/${res.data._id}`);
      }
    } catch (error) {
      console.error("Error saving cart:", error);
    }
  };

  return Savecart;
};
